<template>
  <transition name="modal">
    <div class="modal-mask">
      <!-- <div name="modal" class="modal fade"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> -->
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content history_modal">
          <div class="popup_header">
            <h3>{{ docTitle }}</h3>
          </div>
          <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
            <table class="list_tbl">
              <thead>
                <tr>
                  <th class="mobile_row">{{ $t("product.publishType") }}</th>
                  <th class="mobile_h">{{ $t("product.version") }}</th>
                  <th class="mobile_h">{{ $t("product.state") }}</th>
                  <th class="mobile_h">{{ $t("product.date") }}</th>
                  <th class="mobile_h">{{ $t("product.finalVersion") }}</th>
                  <th class="mobile_h">{{ $t("product.productNumber") }}</th>
                  <th class="mobile_h">{{ $t("product.page") }}</th>
                  <th class="mobile_h">{{ $t("product.regDate") }}</th>
                  <th class="mobile_h"></th>
                </tr>
              </thead>
              <tbody v-if="historyList.length != 0">
                <tr v-for="(item, index) in historyList" :key="index">
                  <td>{{ item.publishedType }}</td>
                  <td>{{ item.versMajor }}.{{ item.versMinor }}</td>
                  <td v-if="item.publishedDate != null">
                    {{ $t("product.distribute") }}
                  </td>
                  <td v-else>{{ $t("product.unDistribute") }}</td>
                  <td>{{ item.publishedDate }}</td>
                  <td v-if="item.maxversYn == 'Y'">Y</td>
                  <td v-else></td>
                  <td>{{ item.partNo }}</td>
                  <td>{{ item.pdfPage }}</td>
                  <td>{{ item.firstRegDatetime }}</td>
                  <td>
                    <a
                      v-if="item.fileNodeRef"
                      @click="
                        pdfDownload(
                          item.fileNodeRef.replace('workspace://SpacesStore/', '')
                        )
                      "
                      class="btn btn-primary btn-lg"
                      title="PDF Download"
                      >Download</a
                    >
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="9">{{dataMessage}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer popup_bottom">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { pdfHistoryList,preDownload } from "@/api/document";
export default {
  props: ["docId", "docTitle"],

  data() {
    return {
      historyList: [],
      authWebhelpYn: "N",
      authViewYn: "N",
      authDownloadYn: "N",
      form: {
        docId: "",
      },
      date: new Date().toISOString(),
      dataMessage : "No information available."
    };
  },
  mounted() {
    this.fetchHistoryData();
  },
  methods: {
    async fetchHistoryData() {
      let loader = this.$loading.show({});
      this.dataMessage = "Loading...";
      try {
        this.form.docId = this.docId;
        const response = await pdfHistoryList(this.form);
        this.historyList = response.data.historyList;
        this.authWebhelpYn = response.data.authWebhelpYn;
        this.authViewYn = response.data.authViewYn;
        this.authDownloadYn = response.data.authDownloadYn;
        this.dataMessage = "No information available.";
        loader.hide();
      } catch (error) {
        this.dataMessage = "No information available.";
        loader.hide();
        console.log(error);
      }
    },
    async pdfDownload(uid) {
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if(response){
        if (response.data.status) {
          loader.hide();
          window.open("/document/download/pdf?uid=" + uid);
        } else {
          loader.hide();
          alert("Download failed");
        }
      }else{
        loader.hide();
        alert("Download failed");
      }
      
    },
  },
};
</script>

<style></style>
